import Vue from "vue";
import {API_HOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class AdminRegistyPermissionService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }

    get(organizationId){
        return Vue.axios.get(`${API_HOST}/api/AdminRegistryPermission`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                organizationId: organizationId ? organizationId : null
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    post({organizationId}) {
        return Vue.axios.post(`${API_HOST}/api/AdminRegistryPermission`, {
            OrganizationId: organizationId
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
        })
    }

    delete(id){
        return Vue.axios.delete(`${API_HOST}/api/AdminRegistryPermission`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: id ? id : null
            }
        })
    }

}

export default new AdminRegistyPermissionService()